<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Tools</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Edit</h5>
      <br />
      <br />
      <b-row>
      <b-col md="4">
        <b-form-group
          id="fieldset-1"
          label="Membership Type"
          label-class="control-label"
          class="required"
          label-for="input-1"
        >
          <b-form-select
            v-model="membership_types"
            name="membership_types"
            v-validate="'required'"
            data-vv-as="Membership Type"
          >
            <template v-slot:first>
              <option value disabled>-- Membership Type --</option>
            </template>
            <option value="gold_and_silver">Gold & Silver</option>
            <option value="gold">Gold</option>
            <option value="silver">Silver</option>
            <option value="gold2.0_and_silver2.0">Gold2.0 & Silver2.0</option>
            <option value="gold2.0">Gold2.0</option>
            <option value="silver2.0">Silver2.0</option>
          </b-form-select>
          <p style="width: 100%; font-size: 80%;color: #e74a3b;">
            {{ veeErrors.first('membership_types') }}
          </p>
        </b-form-group>
      </b-col>
      <b-col md="4">
          <b-form-group
            id="fieldset-1"
            label="Benefit Category"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <b-form-select
              v-model="benefit_category"
              name="benefit_category"
              v-validate="'required'"
              data-vv-as="Benefit Category"
            >
              <template v-slot:first>
                <option value disabled>-- Benefit Category --</option>
              </template>
              <option
                v-for="category_item in category_list"
                :key="category_item.id"
                :value="category_item.id"
              >
                {{ category_item.display }}
              </option>
            </b-form-select>
            <p style="width: 100%; font-size: 80%;color: #e74a3b;">
              {{ veeErrors.first("benefit_category") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            id="fieldset-1"
            label="Benefit Type"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <b-form-select
              v-model="benefit_type"
              name="benefit_type"
              v-validate="'required'"
              data-vv-as="Benefit Type"
            >
              <template v-slot:first>
                <option value disabled>-- Benefit Type --</option>
              </template>
              <option
                v-for="type_item in type_list"
                :key="type_item.id"
                :value="type_item.id"
              >
                {{ type_item.display }}
              </option>
            </b-form-select>
            <p style="width: 100%; font-size: 80%;color: #e74a3b;">
              {{ veeErrors.first("benefit_type") }}
            </p>
          </b-form-group>
        </b-col>
    </b-row>
      <b-row>
      <b-col>
        <b-form-group
            id="input-group-1"
            class="required"
            label-class="control-label"
            label="Image"
            label-for="input-1"
          ></b-form-group>
        <b-card class="text-center bg-gray-100" style="border-style: dashed;">
          <b-row v-if="veeErrors.first('image')" class="m-lg-1" style="background-color: #FEE8E9; border: 1px solid #ffc4c6; border-radius: 5px;">
            <b-col md="12" id="img-error-report">
              <div style="width: 0%; text-align: center; vertical-align: middle; text-align:center;">
                <img src="@/assets/ic-warning-red.svg" class="ic_warning" style="width:25px; position:absolute; margin:auto; top:0; bottom:0;">
              </div>
              <div style="width: 97%; padding-left: 3%;">
                <ul class="text-left" style="margin: 7px 0px;">
                  <li class="text-danger" v-for="imageErr in veeErrors.collect('image')" :key="imageErr"><span class="text-dark">{{ imageErr }}</span></li>
                </ul>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img v-show="!file" v-if="item.image_url" width="100%" :src="item.image_url" />
              <img v-show="file" v-if="url" width="100%" :src="url" />
            </b-col>
          </b-row>
          <input
            type="file"
            ref="file"
            style="display: none"
            name="image"
            v-validate="'minimalDimensions:1000,500|ratiolDimensions:2,1|size:2000|ext:jpg,png,gif,jpeg'"
            @change="onChangeFileUpload()"
          />
          <br />
          <b-link
            @click="$refs.file.click()"
            v-show="!file && !item.image_url"
            variant="primary"
            class="text-primary btn"
          >
            <img class="mr-2" src="@/assets/ic-plus.svg" alt /> Select Image Here
            <label class="text-danger">*</label>
          </b-link>
          <b-button @click="$refs.file.click()" v-show="file || item.image_url" variant="outline-primary" class>
            <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
          </b-button>
          <br />
          <!-- <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p> -->
          <p
            class="text-gray-500"
          >Attach an image (the file must be at least 1000x500 pixels and maximum 2MB. Image must be in JPEG, PNG, or GIF format)</p>
          
        </b-card>
        <br>
        
        <br />
        <label class="text-danger">
          *
          <b class="text-dark">Required</b>
        </label>
      </b-col>

      <b-col md="8">
        <b-row>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title Bahasa"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="'required'"
                name="title_id"
                data-vv-as="Title Bahasa"
                v-model="item.titles.id"
                placeholder="Title Bahasa"
              />
              <b-form-invalid-feedback
                id="input-title_id-feedback"
              >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title English"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="'required'"
                name="title_en"
                data-vv-as="Title English"
                v-model="item.titles.en"
                placeholder="Title English"
              />
              <b-form-invalid-feedback
                id="input-title_en-feedback"
              >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Content Bahasa"
              label-for="input-1"
            >
              <!-- <summer-note v-model="item.contents.id" name="content_id_news" placeholder="Content Bahasa"></summer-note>
              <input type="hidden" v-model="item.contents.id" v-validate="'required'" name="content_id" data-vv-as="Content Bahasa"> -->
              <ckeditor
                :editor="editor"
                tag-name="textarea"
                placeholder="Content Bahasa"
                v-model="item.contents.id"
                class="form-control"
                v-validate="'required'"
                name="content_id"
                data-vv-as="Content Bahasa"
                :config="editorConfig"
              ></ckeditor>
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('content_id') }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Content English"
              label-for="input-1"
            >
              <!-- <summer-note v-model="item.contents.en" name="content_en_news" placeholder="Content English"></summer-note>
              <input type="hidden" v-model="item.contents.en" v-validate="'required'" name="content_en" data-vv-as="Content English"> -->
              <ckeditor
                :editor="editor"
                tag-name="textarea"
                placeholder="Content English"
                v-model="item.contents.en"
                v-validate="'required'"
                name="content_en"
                data-vv-as="Content English"
                class="form-control"
                :config="editorConfig"
              ></ckeditor>
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('content_en') }}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="fieldset-1" :label="dateName" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="20px" alt class />
                </b-col>
                <b-col class="px-0">
                  <vc-date-picker v-model="item.date" :min-date="current_date > item.date ? item.date : current_date" mode="dateTime" color="purple" is24hr>
                    <template v-slot="{ inputValue, inputEvents }">
                      <input
                        class="form-control text-dark pl-0 bg-gray calender-select border-left-0"
                        name="date"
                        data-vv-as="Event Date & Time"
                        :value="inputValue"
                        v-on="inputEvents"
                      />
                    </template>
                  </vc-date-picker>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <!-- <b-col>
            <b-form-group id="fieldset-1" label="End Date" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Select Date"
                    v-model="period_end"
                    :format="customFormatter"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col
                    align="left"
                    class="pt-1 px-4 form-control del-calender-select border-left-0"
                    md="2"
                  >
                    <b-row align="left" class="pt-1">
                      <b-col>
                        <b-link @click="resetEnddate" style="text-decoration:none">
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
              <br />
              <b-row>
              </b-row>
            </b-form-group>
          </b-col> -->
        </b-row>
        <b-row>
          <b-col>
            <b-form-checkbox
              id="extend_info"
              v-model="extend_info"
              name="extend_info"
            >Extend Info</b-form-checkbox>
          </b-col>
        </b-row>
        <br />
        <b-row v-show="extend_info">
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              label-class="control-label"
              label="PIC"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                name="pic_name"
                data-vv-as="PIC"
                v-model="item.pic_name"
                placeholder="PIC"
              />
              <b-form-invalid-feedback
                id="input-pic_name-feedback"
              >{{ veeErrors.first('pic_name') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="extend_info">
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              label-class="control-label"
              label="No Contact"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                name="pic_contact"
                data-vv-as="No Contact"
                v-model="item.pic_contact"
                placeholder="No Contact"
              />
              <b-form-invalid-feedback
                id="input-pic_contact-feedback"
              >{{ veeErrors.first('pic_contact') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="extend_info">
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              label-class="control-label"
              label="Url Link"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                name="link_url"
                data-vv-as="Url Link"
                v-model="item.link_url"
                placeholder="Url Link"
              />
              <b-form-invalid-feedback
                id="input-link_url-feedback"
              >{{ veeErrors.first('link_url') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="extend_info">
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              label-class="control-label"
              label="Location"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                name="location"
                data-vv-as="Location"
                v-model="item.address"
                placeholder="Location"
              />
              <b-form-invalid-feedback
                id="input-location-feedback"
              >{{ veeErrors.first('location') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row class="text-right mt-2">
          <b-col>
            <b-button variant="primary" @click="post()" :disabled="loading" class="mr-5">Update</b-button>
            <router-link :to="{name: 'Benefit'}">
              <b-button variant="outline-secondary">Cancel</b-button>
            </router-link>
          </b-col>
        </b-row>
        <b-modal v-model="modalShow" title="Preview Image" size="xl">
          <img v-if="url" width height="400px" :src="url" />
        </b-modal>
      </b-col>
    </b-row>
    </b-card>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
// import summerNote from "@/components/Summernote.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";

export default {
  mixins: [mixInCkeditor],
  components: {
    Datepicker,
    // summerNote
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      isHiddenBahasa: false,
      isHiddenEnglish: false,
      loading: false,
      benefit_type: "",
      benefit_category: "",
      membership_types: "",
      selected: "first",
      checked: false,
      modalShow: false,
      file_webp: "",
      widthImage_webp: null,
      heightImage_webp: null,
      url_webp: "",
      item: {
          id: "",
          address: "",
          contents: {
              en: "",
              id: ""
          },
          image_url: "",
          link_url: "",
          membership_types: [],
          pic_contact: "",
          pic_name: "",
          titles: {
              en: "",
              id: ""
          },
          type: "",
          date: ""
      },
      file: "",
      widthImage: null,
      heightImage: null,
      InputImage: false,
      url: "",
      image_alt: "",
      title_id: "",
      title_en: "",
      content_id: "",
      content_en: "",
      pic: "",
      no_contact: "",
      url_link: "",
      date: "",
      period_end: "",
      is_always_active: false,
      extend_info: false,
      counthighlight: '',
      options: [],
      tag: "",
      tags: [],
      type_list: [],
      category_list: [],
      current_date: new Date(),
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      }
    };
  },
  beforeCreate() {
    this.$store
      .dispatch("BenefitCategoryModule/getBenefitCategories")
      .then((response) => {
        this.category_list = response.data.data.categorys || [];
        this.loading = false;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
      
    const formData = new FormData();
    formData.append("benefit_code", this.$route.params.benefit_code);
    this.$store
      .dispatch("BenefitModule/getBenefits", formData)
      .then((response) => {
        if (response.data.data.benefits.length > 0) {
          this.item = response.data.data.benefits[0];
          if (this.item && typeof this.item.date == "string") {
            if (this.item.date != "") {
              this.item.date = moment(this.item.date, "DD-MM-YYYY HH:mm").toDate();
            }
          }
          if (this.isGoldAndSilver(this.item.membership_types)){
            this.membership_types = "gold_and_silver"
          } else if (this.isGold20AndSilver20(this.item.membership_types)){
            this.membership_types = "gold2.0_and_silver2.0"
          } else{
            this.membership_types = this.item.membership_types[0]
          }
          this.benefit_category = this.item.benefit_category.id;
          this.extend_info = this.item.pic_name != "" || this.item.pic_contact != "" || this.item.link_url != "" || this.item.address != "";
        }
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
  },
  computed: {
    membership(){
      if (this.isGoldAndSilver(this.item.membership_types)){
        return "gold_and_silver"
      } else if (this.isGold20AndSilver20(this.item.membership_types)){
        return "gold2.0_and_silver2.0"
      } else{
        return this.item.membership_types[0]
      }
    },
    dateName() {
      return this.extend_info ? "Date & Time" : "Valid Until";
    }
  },
  methods: {
    isGoldAndSilver(membership) {
      if (typeof membership !== 'undefined') {
        return membership.includes("gold") && membership.includes("silver");
      }
      return false;
    },
    isGold20AndSilver20(membership) {
      if (typeof membership !== 'undefined') {
        return membership.includes("gold2.0") && membership.includes("silver2.0");
      }
      return false;
    },
    resetStardate() {
      this.date = "";
    },
    resetEnddate() {
      this.period_end = "";
    },
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const formData = new FormData();
          formData.append("benefit_type_id", this.benefit_type);
          formData.append("titles_en", this.item.titles.en);
          formData.append("titles_id", this.item.titles.id);
          formData.append("contents_en", this.item.contents.en);
          formData.append("contents_id", this.item.contents.id);
          formData.append("image_url", this.file);
          formData.append("existing_image_url", this.item.image_url);

          if (this.extend_info) {
            formData.append("pic_name", this.item.pic_name);
            formData.append("pic_contact", this.item.pic_contact);
            formData.append("link_url", this.item.link_url);
            formData.append("address", this.item.address);
          } else {
            formData.append("pic_name", "");
            formData.append("pic_contact", "");
            formData.append("link_url", "");
            formData.append("address", "");
          }

          if(this.item.date != "" && this.item.date != null) {
            formData.append(
              "date",
              moment(this.item.date).format("YYYY-MM-DDTHH:mm")
            );
          }
          
          if (this.membership_types == "gold_and_silver") {
            formData.append("membership_types", "gold");
            formData.append("membership_types", "silver");
          } else if (this.membership_types == "gold2.0_and_silver2.0") {
            formData.append("membership_types", "gold2.0");
            formData.append("membership_types", "silver2.0");
          } else {
            formData.append("membership_types", this.membership_types);
          }

          this.loading = true;
          const payload = {
            id:this.item.id,
            data:formData
          }
          this.$store
            .dispatch("BenefitModule/putBenefit", payload)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "Benefit" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
            })
            .catch(error => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500
              });
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.url = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileWebp() {
      this.file_webp = this.$refs.file_webp.files[0];
      const input = this.$refs.file_webp;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage_webp = img.width;
            this.heightImage_webp = img.height;
          };
          img.src = e.target.result;
          this.url_webp = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  },
  watch: {
    benefit_category(newVal, oldVal) {
      if (newVal) {
        const formData = new FormData();
        formData.append("category_id", newVal);
        this.$store
          .dispatch("BenefitTypeModule/getBenefitTypes", formData)
          .then((response) => {
            this.type_list = response.data.data.type_benefits || [];
            if (this.benefit_type == "") {
              this.benefit_type = this.item.benefit_type.id;
            } else {
              this.benefit_type = "";
            }
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: error.response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style scoped>
</style>
